<!-- form panel -->
<datalist id="zip-codes">
    @for (address of zipCodeList; track address) {
        <option (click)="selectZipCode(address)" [value]="address.zipcode">{{address.zipcode}}, {{address.city}}</option>
    }
</datalist>

<div class="card">
    <div class="card-header d-flex align-tems-center justify-content-between">
        <div>
            <button class="btn btn-light btn-sm" (click)="expanded = !expanded">
                @if (expanded) {
                    <span class="dripicons-chevron-up"></span>
                }
                @if (!expanded) {
                    <span class="dripicons-chevron-down"></span>
                }
            </button>

            {{ words[language][ 'addresses' ] }} <span class="badge badge-light">{{(addressesList && (addressesList.length > 0)) ? addressesList.length : ''}}</span>
        </div>

        @if (contactId) {
            <button (click)="cleanFields(true)" title="Add Address" data-toggle="modal" data-target="#Addresses" title="Add" class="btn btn-sm btn-primary">
                <span class="uil-plus"></span>
            </button>
        }
    </div>

    @if (expanded) {
    <div>
        <div class="card-body" [ngClass]="{'d-none': addressesList.length == 0 }">
            <div class="row text-dark">
                @for (address of addressesList; track address; let i = $index) {
                    <div class="col-md-4 col-sm-12">
                        <div class="card ribbon-box border">
                            @if (address.primaryAddress) {
                                <div class="ribbon-two ribbon-two-primary">
                                    <span>{{ words[language][ 'default' ] }}</span>
                                </div>
                            }
                            <div class="card-header">
                                <div class="font-weight-bold text-center">
                                    {{ address.addressType.type }}
                                </div>
                            </div>
                            <div class="card-body">
                                <table>
                                    <tbody>
                                        <td>
                                            <tr>{{address.address}}, {{address.address2}}</tr>
                                            <tr>{{address.city}}, {{address.state}} {{address.zipCode}}</tr>
                                        </td>
                                    </tbody>
                                </table>
                            </div>
                            <!-- header -->
                            <div class="card-footer text-center">
                                <button class="btn btn-sm text-dark" title="Set as Default" [name]="address.id" [id]="address.id" (click)="selectDefault(address.id)" [ngClass]="{'d-none': address.primaryAddress}">Set as Default</button>
                                <button class="btn btn-sm text-dark" title="Map Me!" (click)="openLocation(address.address,address.county,address.state )">Locate
                                </button>
                                <button class="btn btn-sm text-dark" data-toggle="modal" title="Edit" data-target="#updateAddressModal" (click)="getAddress(address.id)">
                                    Edit
                                </button>
                                <button class="btn btn-sm text-danger" data-toggle="modal" title="Delete" data-target="#deleteAddressModal" (click)="selectAddress(address.id)">
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
    }
</div>

<!-- ? modals -->
<div id="Addresses" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="standard-modalLabel">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-light">
                <h4 class="modal-title " id="standard-modalLabel">{{ words[language][ 'addNewAddress' ] }}</h4>
                <button type="button" class="close" data-dismiss="modal">×</button>
            </div>
            <div class="modal-body">
                <!-- body -->
                <form [formGroup]="information" class="row">
                    <!-- type input-->
                    <div class="form-group col-12 my-1">
                        <label for="addressTypeId">{{ words[language][ 'type' ] }}</label>
                        <select class="form-control" id="addressTypeId_new" formControlName="addressTypeId">
                            @for (addyType of types; track addyType.id) {
                                <option [value]="addyType.id">{{ words[language][ addyType.type.toLowerCase() ] }}</option>
                            }
                        </select>
                    </div>
                    <!-- adress input -->
                    <div class="form-group col-md-8 col-sm-12 my-1">
                        <label for="address">{{ words[language][ 'address' ] }}</label>
                        <input class="form-control" type="text" id="address_new" formControlName="address" autocomplete="off">
                        @if (address.invalid && address.dirty) {
                            <span class="text-danger">{{ words[language]['invalidAddress' ] }}</span>
                        }
                    </div>
                    <!--  adress 2 input -->
                    <div class="form-group col-md-4 col-sm-12 my-1">
                        <label for="address2">{{ words[language][ 'address' ] }} 2</label>
                        <input class="form-control" type="text" id="address2_new" formControlName="address2" autocomplete="off">
                        @if (address2.invalid && address2.dirty) {
                            <span class="text-danger">{{ words[language]['invalidAddress' ] }}</span>
                        }
                    </div>
                    <!--  Zip Code input -->
                    <div class="form-group col-md-4 col-sm-12 my-1">
                        <label for="zipCode">{{ words[language][ 'zipcode' ] }}</label>
                        <div class="position-relative hover-list">
                            <input class="form-control" type="text" id="zipCode_new" formControlName="zipCode" (keyup)="searchZipCode()" list="zip-codes" autocomplete="off">
                        </div>

                        @if (zipCode.invalid && zipCode.dirty) {
                            <span class="text-danger">{{ words[language]['invalidZipcode' ] }}</span>
                        }
                    </div>
                    <!--  City input -->
                    <div class="form-group col-md-4 col-sm-12 my-1">
                        <label for="zipCode">{{ words[language][ 'city' ] }}</label>
                        <input class="form-control" type="text" id="city_new" formControlName="city" autocomplete="off" readonly>
                    </div>
                    <!--  State input -->
                    <div class="form-group col-md-4 col-sm-12 my-1">
                        <label for="zipCode">{{ words[language][ 'state' ] }}</label>
                        <input class="form-control" type="text" id="state_new" formControlName="state" autocomplete="off" readonly>
                    </div>
                    <!--  County input -->
                    <div class="form-group col-md-6 col-sm-12 my-1">
                        <label for="zipCode">{{ words[language][ 'county' ] }}</label>
                        <input class="form-control" type="text" id="county_new" formControlName="county" autocomplete="off" readonly>
                    </div>
                    <!--  Country input -->
                    <div class="form-group col-md-6 col-sm-12 my-1">
                        <label for="zipCode">{{ words[language][ 'country' ] }}</label>
                        <input class="form-control" type="text" id="country_new" formControlName="country" autocomplete="off" readonly>
                    </div>
                </form>
                <div class="modal-footer">

                    <!--  -->
                    <!-- <div class="col-md-12 d-flex justify-content-end px-3 mt-2"> -->
                    <!-- add button -->
                    <button class="btn btn-success mr-2" id="btn-add-addresses_new" (click)="add(information.value)" [disabled]="information.invalid || loading">
                        @if (loading) {
                            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                        }
                        Add Another
                    </button>
                    <!-- save button -->
                    <button class="btn btn-success mr-2" id="btn-save-addresses_new" [disabled]="information.invalid || loading" (click)="save(true)">
                        @if (loading) {
                            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                        }
                        {{ words[language][ 'save' ] }}
                    </button>
                    <!-- cancel button -->
                    <button class="btn btn-light" id="btn-cancel-addresses" data-dismiss="modal" data-dismiss="modal">{{words[language][ 'cancel' ] }}</button>
                    <!-- </div> -->
                </div>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- ! delete modal -->
<div class="modal fade" id="deleteAddressModal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="dripicons-cross text-danger h1"></span>
                <h4 class="text-danger w-100 text-center">{{ words[language][ 'delete' ] }}</h4>
                <span class="text-muted my-3 text-center">{{ words[language][ 'deleteAddress' ] }}</span>

                <button class="btn btn-danger mt-2" (click)="delete()" [disabled]="loading">
                    @if (loading) {
                        <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    Yes
                </button>
                <button type="button" class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="close-delete-modal">No</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- todo: upadate modal -->
<div id="updateAddressModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="standard-modalLabel">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-light">
                <h4 class="modal-title " id="standard-modalLabel">{{ words[language][ 'updateAddress' ] }}</h4>
                <button type="button" class="close" data-dismiss="modal">×</button>
            </div>
            <div class="modal-body">
                <!-- body -->
                <form [formGroup]="information" class="row">
                    <!-- type input-->
                    <div class="form-group col-12 my-1">
                        <label for="addressTypeId">{{ words[language][ 'type' ] }}</label>
                        <select class="form-control" id="addressTypeId_new" formControlName="addressTypeId">
                            @for (addyType of types; track addyType.id) {
                                <option [value]="addyType.id">{{ words[language][ addyType.type.toLowerCase() ] }}</option>
                            }
                        </select>
                    </div>
                    <!-- adress input -->
                    <div class="form-group col-md-8 col-sm-12 my-1">
                        <label for="address">{{ words[language][ 'address' ] }}</label>
                        <input class="form-control" type="text" id="address_update" formControlName="address" autocomplete="address-level1">
                        @if (address.invalid && address.dirty) {
                        <span class="text-danger">{{ words[language]['invalidAddress' ] }}</span>
                        }
                    </div>
                    <!--  adress 2 input -->
                    <div class="form-group col-md-4 col-sm-12 my-1">
                        <label for="address2">{{ words[language][ 'address' ] }} 2</label>
                        <input class="form-control" type="text" id="address2_update" formControlName="address2" autocomplete="address-line1">
                        @if (address2.invalid && address2.dirty) {
                        <span class="text-danger">{{ words[language]['invalidAddress' ] }}</span>
                        }
                    </div>
                    <!--  Zip Code input -->
                    <div class="form-group col-md-4 col-sm-12 my-1">
                        <label for="zipCode">{{ words[language][ 'zipcode' ] }}</label>
                        <div class="position-relative hover-list">
                            <input class="form-control" type="search" id="zipCode" formControlName="zipCode" (keyup)="searchZipCode()" list="zip-codes" autocomplete="off">
                        </div>
                        @if (zipCode.invalid && zipCode.dirty) {
                        <span class="text-danger">{{ words[language]['invalidZipcode' ] }}</span>
                        }
                    </div>
                    <!--  City input -->
                    <div class="form-group col-md-4 col-sm-12 my-1">
                        <label for="zipCode">{{ words[language][ 'city' ] }}</label>
                        <input class="form-control" type="text" id="city" formControlName="city" autocomplete="off" readonly>
                    </div>
                    <!--  State input -->
                    <div class="form-group col-md-4 col-sm-12 my-1">
                        <label for="zipCode">{{ words[language][ 'state' ] }}</label>
                        <input class="form-control" type="text" id="state" formControlName="state" autocomplete="off" readonly>
                    </div>
                    <!--  County input -->
                    <div class="form-group col-md-6 col-sm-12 my-1">
                        <label for="zipCode">{{ words[language][ 'county' ] }}</label>
                        <input class="form-control" type="text" id="county" formControlName="county" placeholder="Enter Your County" autocomplete="off" readonly>
                    </div>
                    <!--  Country input -->
                    <div class="form-group col-md-6 col-sm-12 my-1">
                        <label for="zipCode">{{ words[language][ 'country' ] }}</label>
                        <input class="form-control" type="text" id="country" formControlName="country" placeholder="Enter Your Country" autocomplete="off" readonly>
                    </div>
                </form>
                <div class="modal-footer">
                    <!-- save button -->
                    <button class="btn btn-success mr-2" id="btn-save-addresses" [disabled]="information.invalid || loading" (click)="modifyAddress(information.value)">
                        @if (loading) {
                            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                        }
                        {{ words[language][ 'update' ] }}
                    </button>
                    <!-- cancel button -->
                    <button class="btn btn-light" id="btn-close-addresses-update" data-dismiss="modal" data-dismiss="modal">{{ words[language][ 'cancel' ] }}</button>
                </div>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->